var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("PatAppointmentsBPage")]),_c('v-overlay-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }